import { __rest } from "tslib";
import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { isEqual } from '@as-react/common-utils';
export const useDebouncedQuery = (queryOptions, debounceTime = 500) => {
    const { queryKey, queryFn } = queryOptions, options = __rest(queryOptions, ["queryKey", "queryFn"]);
    const [debouncedKey, setDebouncedKey] = useState(queryKey);
    useEffect(() => {
        const handler = setTimeout(() => {
            if (!isEqual(queryKey, debouncedKey)) {
                setDebouncedKey(queryKey);
            }
        }, debounceTime);
        return () => clearTimeout(handler);
    }, [queryKey, debounceTime]);
    return useQuery(Object.assign(Object.assign({}, options), { queryKey: debouncedKey, queryFn }));
};
